import config from './index';

const routes = {

    //login
    login: config.api_url+'login',

     //signup
     signupApi: config.api_url+'signup',

    //logout
    logout: config.api_url+'logout',

    //UploadDocument
    uploadImageApi: config.api_url+'upload-image',
    removeFileApi: config.api_url+'remove-File',
    uploadDocumentApi: config.api_url+'upload-document',
    uploadApi: config.api+'upload',
    uploadDriveProfileApi: config.api_url+'update-driver-profile',
    uploadProfileImageApi: config.api+'update-driver-profile',

    //Setting
    getSettingApi: config.api_url+'get-setting',
    updateSettingApi: config.api_url+'update-setting',
    getAppLayoutSettingApi : config.api_url+'get-app-layout-setting',
    updateAppLayoutApi: config.api_url+'update-app-layout-setting',
    updateGeneralTerminologyApi: config.api_url+'update-general-terminology-setting',
    getOrderNotificationTextApi: config.api_url+'get-order-notification',
    updateOrderTextApi : config.api_url+'update-text-notification',
    updatepaymentgatewayApi: config.api_url+'update-payment-gateway',
    getVendorSettingByIdApi: config.api_url+'get-setting-by-id',
    getPaymentGatewayList: config.api_url+'get-payment-gatewaylist',

    //UserDetail
    userDetailApi: config.api_url+'user-detail',
    userCheckEmailApi: config.api_url+'user-check-email',

    //ApiText
    getApiTextApi: config.api_url+'get-api-text',
    addApiTextApi: config.api_url+'add-api-text',
    updateApiTextApi: config.api_url+'update-api-text',

    //Customer
    getCustomerApi: config.api_url+'get-customer',
    getB2bCutomerProductsApi: config.api_url+'get-b2b-cutomer-products',
    individualSubProductSave: config.api_url+'individual-sub-product-save',
    //getCustomerCreditApi: config.api_url+'get-customer-credit',
    customerExportToCsvApi: config.api_url+'customer-export-csv',
    getCustomerProfileApi: config.api_url+'get-customer-profile',
    updateCustomerProfileApi: config.api_url+'update-customer-profile',
    getCustomerOrderApi: config.api_url+'get-customer-order',
    changeCusPasswordApi: config.api_url+'change-cust-password',
    addCustomerApi: config.api_url+'add-customer',
    userProfileDeleteUrl: config.api_url+'user-profile-delete',
    companyLogoDeleteUrl: config.api_url+'company-logo-delete',
    changeCustomerStatusApi: config.api_url+'customer-status-change',
    deleteCustomerApi: config.api_url+'delete-customer',
    unblockCustomerApi: config.api_url+'unblock-customer',
    getCustomerOrdersApi: config.api_url+'get-customer-orders',
    getCustomerTypeApi: config.api_url+'get-type-customer',
    

    //Driver
    getDriverApi: config.api_url+'get-driver',
    driverExportToCsvApi: config.api_url+'driver-export-csv',
    getDriverInfoApi: config.api_url+'get-driver-info',
    getPrvDriverInfoApi: config.api_url+'get-prv-driver-info',
    getFrenchiseApi: config.api_url+'get-frenchisee',
    addDriverApi: config.api_url+'add-driver',
    getDriverRatingApi: config.api_url+'get-driver-rating',
    updateDriveProfileApi: config.api_url+'update-driver-profile',
    driverProfileDeleteUrl: config.api_url+'driver/delete-profile-by-name',
    driverDocumentDeleteUrl: config.api_url+'driver/delete-document-by-name',
    driverLicenceDeleteUrl: config.api_url+'driver/delete-licence-by-name',
    driverByAvailabilityApi: config.api_url+'driver/availablilty/get',
    updateDriverStatusApi: config.api_url+'update-driver-status',
    updateAvailbilityStatusApi: config.api_url+'update-driver-availbilty-status',
    changeDriverPasswordApi: config.api_url+'change-driver-password',
    deleteDriverApi: config.api_url+'delete-driver',

    // getDriverDashboardApi: config.api_url+'get-driver-dashboard',
    // Eagleview
    eagleViewDriverListApi: config.api_url+'get-eagleview',

    //Vendor
    getVendorApi: config.api_url+'get-vendor',
    getVendorDetailApi: config.api_url+'restaurant-export-csv',    
    getVendorCategoryApi: config.api_url+'get-vendor-category',
    getRestaurantCategoryApi: config.api_url+'get-res-category',
    // getRestaurantCuisineApi: config.api_url+'get-res-cuisine',
    getRestaurantbyIdApi: config.api_url+'get-restaurant-detail-by-id',
    changePasswordApi: config.api_url+'change-password',
    addVendorApi: config.api_url+'add-restaurant',
    addRestaurantCategoryApi: config.api_url+'add-menu-category',
    getMenuCategoryByIdApi: config.api_url+'get-category-menu-by-id',
    updateRestaurantCategoryApi: config.api_url+'update-menu-category',
    deleteMenuCategoryApi: config.api_url+'delete-menu-category',
    vendorImageDeleteUrl: config.api_url+'restaurant/delete-icon-by-name',
    categroyImageDeleteUrl: config.api_url+'restaurant/delete-category-image-by-name',
    getBusinessProfileApi: config.api_url+'get-business-profile',
    getLanguageApi: config.api_url+'get-language',
    updateBusinessProfileApi: config.api_url+'update-business-profile',
    getVendorLanguageApi: config.api_url+'get-vendor-language',
    getRestaurantMenuApi: config.api_url+'restaurant/menu',
    getItemByMenuIDApi:config.api_url+'restaurant/menu/item',
    deleteAppLogoApi: config.api_url+'delete-app-logo',
    deleteFlatIconApi: config.api_url+'delete-flat-icon',
    addMenuApi: config.api_url+'add-menu',
    editMenuApi: config.api_url+'edit-menu',
    getMenuByIdApi: config.api_url+'get-menu-by-id',
    resImageDeleteUrl: config.api_url+'delete-menu-image',
    updateMenuStatusApi: config.api_url+'update-menu-status',
    addItmeMenuApi: config.api_url+'add-menu-item',
    getResTimeSlotApi: config.api_url+'get-res-time-slot',
    getMenuCategoriesApi: config.api_url+'get-menu-categrory-list',
    addTimeSlotApi : config.api_url+'add-time-slot',
    getSelingTimes: config.api_url+'get-sellingtime-slot',
    removeSellingTime: config.api_url+'remove-sellingtime-slot',
    getRestaurantOperationTimeApi: config.api_url+'vendor/get-operation-time',
    saveRestaurantOperationTimeApi: config.api_url+'vendor/save-operation-time',
    restaurantOnOffApi: config.api_url+'vendor/restaurant-on-off',
    getMenuItemApi: config.api_url+'get-menu-item',
    deleteMenuApi: config.api_url+'delete-menu',
    deleteMenuWithItemApi: config.api_url+'delete-menu-with-item',
    menuItemEditApi: config.api_url+'update-menu-item',
    deleteMenuItemApi: config.api_url+'delete-menu-item',
    getCustomizationApi: config.api_url+'get-item-customization',
    getMenuImageApi: config.api_url+'get-menu-item-image',
    menuImageDeleteUrl: config.api_url+'delete-menu-image-by-id',
    changeResPasswordApi: config.api_url+'change-res-password',
    importMenuItemApi: config.api_url+'import-menu-item',
    importProductNumberApi: config.api_url+'import-product-numbers',
    getDeliveryZonesApi: config.api_url+'vendor/delivery_zones',
    updateUserPasswordApi: config.api_url+'vendor/user/change-password',
    updateStatusApi: config.api_url+'update-status',
    updateMenuOrderApi: config.api_url+'update-menu-order',
    updateItemOrderApi: config.api_url+'update-item-order',
    updateItemAvailabilityApi: config.api_url+'update-item-availability',
    updateMenuCatOrderApi: config.api_url+'category-order-update',

    //Cuisine
    // getCuisineApi: config.api_url+'get-cuisine',
    // getCuisineListApi: config.api_url+'cuisine-export-csv',
    // addCuisineApi: config.api_url+'add-cuisine',
    // getCuisineByIdApi: config.api_url+'get-cuisine-by-id',
    // updateCuisineApi: config.api_url+'update-cuisine',
    // deleteCuisineApi: config.api_url+'delete-cuisine',
    // cuisineImageDeleteUrl: config.api_url+'cuisine/delete-cuisine-by-name',

    //Location
    getCountryListApi: config.api_url+'get-country-list',
    getStateListApi: config.api_url+'get-state-list',
    getCityListApi: config.api_url+'get-city-list',
    addCountryApi: config.api_url+'add-country',
    addStateApi: config.api_url+'add-state',
    addCityApi: config.api_url+'add-city',
    updateCountryApi: config.api_url+'update-country',
    updateStateApi: config.api_url+'update-state',
    updateCityApi: config.api_url+'update-city',
    getCountryByIdApi: config.api_url+'get-country-by-id',
    getStateByIdApi: config.api_url+'get-state-by-id',
    getCityByIdApi: config.api_url+'get-city-by-id',

    //Banners
    getBannerApi: config.api_url+'get-banner',
    addbannerApi: config.api_url+'add-banner',
    getRestaurantApi: config.api_url+'get-restaurant',
    getBannerByIdApi: config.api_url+'get-banner-by-id',
    updateBannerApi: config.api_url+'update-banner',
    deleteBannerApi: config.api_url+'delete-banner',
    bannerImageDeleteUrl: config.api_url+'banner/delete-banner-by-name',
    updateBannerOrderApi: config.api_url+'update-banner-order',

    //Category
    getCategoryApi: config.api_url+'get-category',
    categoryExportToCsvApi: config.api_url+'category-export-csv',
    addCategoryApi: config.api_url+'add-category',
    getCategoryByIdApi: config.api_url+'get-category-by-id',
    updateCategoryApi: config.api_url+'update-category',
    deleteCategoryApi: config.api_url+'delete-category',
    categoryImageDeleteUrl: config.api_url+'category/delete-category-by-name',
    navigationImageDeleteUrl: config.api_url+'category/delete-navigation-image',
    updateCategoryOrderApi: config.api_url+'update-category-order',
    getAttributeApi: config.api_url+'get-attribute',
    getAttValueApi: config.api_url+'get-attribute-value',
    getTaxes: config.api_url+'get-taxes',
    // getAttributeSizeApi: config.api_url+'get-attribute-size',

    //PromoCode
    getPromoCodeApi: config.api_url+'get-promocode',
    promoCodeExportToCsvApi: config.api_url+'promocode-export-csv',
    addPromoCodeApi: config.api_url+'add-promocode',
    getCustomerLisingApi: config.api_url+'get-customer-listing',
    getPromoCodeByIdApi: config.api_url+'get-promocode-by-id',
    promoCodeImageDeleteUrl: config.api_url+'promocode/delete-promocode-by-name',
    updatePromoCodeApi: config.api_url+'update-promocode',
    getSubcategorySearchApi: config.api_url+'get-search-sub-category',
    getProductSearchApi: config.api_url+'get-product-by-search',
    deletePromocodeApi: config.api_url+'delete-promocode',
    applyPromoCodeApi: config.api_url+'coupon-reedme',
    
    //DeliveryZone
    getPostalCodeApi: config.api_url+'get-postal-codes',
    addPostalCodeApi: config.api_url+'add-postal-code',
    editPostalCodeApi: config.api_url+'edit-postal-code',
    getPostalCodeInfoApi: config.api_url+'get-postal-code-info',
    deletePostalCodeApi: config.api_url+'delete-postal-code',

    getDeliveryZoneApi: config.api_url+'get-delivery-zone',
    getVendorCountryApi: config.api_url+'get-vendor-country',
    getVendorStateApi: config.api_url+'get-vendor-state',
    getVendorCityApi: config.api_url+'get-vendor-city',
    getAllStateApi: config.api_url+'get-all-state',
    getAllCityApi: config.api_url+'get-all-city',
    addDeliveryZoneApi: config.api_url+'add-delivery-zone',
    getDeliveryInfoApi: config.api_url+'get-delivery-info',
    editDeliveryZoneApi: config.api_url+'edit-delivery-zone',
    zoneExportCsvApi: config.api_url+'zoneExportCsv',
    deleteZoneApi: config.api_url+'delete-delivery-zone',
    checkPostalCodeApi: config.api_url+'check-postal-code',
    checkBillPostalCodeApi: config.api_url+'check-bill-postal-code',
    zoneImageDeleteUrl: config.api_url+'delete-delivery-zone-image',

    //Restaurant
    getRestaurantListApi: config.api_url+'get-restaurant-list',
    getRestaurantDetailApi: config.api_url+'restaurant-export-csv',
    getRestaurantCategoryListApi: config.api_url+'get-res-category',
    addRestaurantApi: config.api_url+'add-restaurant',
    getRestaurantById: config.api_url+'restaurant/get',
    getRatingApi: config.api_url+'get-rating',
    getBankInfoApi: config.api_url+'restaurant/bank-info',

    getDayWiseFinanceApi: config.api_url+'restaurant/finance/daywise',
    getPastDayWiseFinanceApi: config.api_url+'restaurant/finance/pastdaywise',
    getMonthwiseRestaurantEarningsApi: config.api_url+'restaurant/finance/monthwise',
    getOrderwiseRestaurantEarningsApi: config.api_url+'restaurant/finance/orderwise',
    getOrderwiseRestaurantEarningsExportApi: config.api_url+'restaurant/finance/orderwise/export',
    getRestaurantSettlementApi: config.api_url+'restaurant/finance/settlements',
    paySettlementApi: config.api_url+'restaurant/finance/pay-settlements',
    getTransactionsApi: config.api_url+'restaurant/finance/get-transactions',
    menuItemExportApi: config.api_url+'menu-item-export-csv',

    //Rating
    getRestaurantRatingApi: config.api_url+'get-restaurant-rating',
    getRestaurantAvgRatingApi: config.api_url+'get-restaurant-avg-rating',

    //VendorInfo
    updateVendorInfoApi: config.api_url+'update-vendor-info',
    vendorSignupApi: config.api_url+'vendor/signup',
    
    parkingPlaceApi: config.api_url+'parking-place',
    
    
    //user-access
    getUserRolesApi: config.api_url+'user-access/get-all-roles',
    addUserRoleApi: config.api_url+'user-access/add-role',
    addPermissionApi: config.api_url+'user-access/add-permission',
    getPermissionsByGuardApi: config.api_url+'user-access/get-permission-by-user',
    changePermissionsByRoleApi: config.api_url+'user-access/change-permissions-by-role',
    getAccessUsersApi: config.api_url+'user-access/get-access-users',
    addUserApi: config.api_url+'user-access/add-user',
    getAllPermissionsApi: config.api_url+'user-access/get-all-permissions',
    getUserPermissionsApi: config.api_url+'user-access/get-user-permissions',
    getUserDetailApi: config.api_url+'user-access/get-user-details',
    updateUserPermissionsApi: config.api_url+'user-access/update-user-permissions',
    updateUserApi: config.api_url+'user-access/update-user',
    getAuthPermissionsApi: config.api_url+'user-access/get-auth-permissions',

    // Vendor Finance 
    getVendorFinanceApi: config.api_url+'finance/vendor',
    getVendorFinanceCsvApi: config.api_url+'finance/csv/vendor',
    getVendorFinanceMonthApi: config.api_url+'finance-month/vendor',
    getVendorFinanceMonthCsvApi: config.api_url+'finance-month/vendor/csv',
    
    //upload-image
    uploadTmpImageApi: config.api_url+'upload-temp-image',
    removeTmpImageApi: config.api_url+'remove-temp-image',
 
    // Faq
    getFaqListingApi: config.api_url+'get-faq-listing',
    addFaqApi: config.api_url+'add-faq',
    getFaqByIdApi: config.api_url+'get-faq-by-id',
    updateFaqApi: config.api_url+'update-faq',
    deleteFaqApi: config.api_url+'delete-faq',
    getFaqCategoryListApi: config.api_url+'get-faq-category-list',
    updateFaqCategoryOrderApi: config.api_url+'update-faq-category-order',
    addFaqCategoryApi: config.api_url+'add-faq-category',
    getFaqCategoryByIdApi: config.api_url+'get-faq-category-by-id',
    iconDeleteUrl: config.api_url+'delete-icon-by-name',
    updateFaqCategoryApi: config.api_url+'update-faq-category',
    deleteFaqCategoryApi: config.api_url+'delete-faq-category',
    getAllFaqCategoryApi: config.api_url+'all-faq-category',

    // LogActivity
    getLogActivityApi: config.api_url+'get-log-activity',
    getCsvLogApi: config.api_url+'get-csv-logs',
    
    //Driver Finance
    getDriverFinanceApi: config.api_url+'driver/finance',
    getDriverFinanceMonthApi: config.api_url+'driver/finance-month',
    getDriverFinanceDaysApi: config.api_url+'driver/finance/days',
    getDriverDayWiseDataApi: config.api_url+'driver/finance/day-wise',
    getDriverSevenDayEarningApi: config.api_url+'driver/finance/last-seven-day',
    getDriverMonthWiseEarningApi: config.api_url+'driver/finance/month-earning',
    getDriverOrderWiseEarningApi: config.api_url+'driver/finance/order-earning',
    getDriverSettlementsApi: config.api_url+'driver/finance/settlements',
    getDriverPendingSettlementApi: config.api_url+'driver/finance/pending',
    receiveDriverSettlementApi: config.api_url+'driver/finance/receive',
    driverTransactionsApi: config.api_url+'driver/finance/get-transactions',
    
    //upload-ios-pushnotification-pem file
    uploadIOSPemApi: config.api_url+'upload-ios-pem',
    removeIOSPemApi: config.api_url+'remove-ios-pem',
    
    //Orders
    getDriverOrders: config.api_url + 'orders/driver/get',
    getOrdersApi: config.api_url+'orders/get',
    getNewOrdersApi: config.api_url+'orders/new/get',
    getParkingAssignApi: config.api_url+'orders/parkingAssgin',
    exportOrdersApi: config.api_url+'orders/export',
    getOrderApi: config.api_url+'order/get',
    getOrderAdminApi: config.api_url+'order/get/admin',
    getOrdersCountApi: config.api_url+'order/get/count',
    getDriverOrdersCountApi: config.api_url+'order/driver/get/count',
    checkAvailableDriversApi: config.api_url+'delivery_zone/drivers',
    assignDriverApi: config.api_url+'order/assign_driver',
    reassignDriverApi: config.api_url+'order/reassign_driver',
    getOrderDateDotsApi: config.api_url+'order/date-dots',
    getCustomerByEmailApi: config.api_url+'order/get_customer_by_email',
    addOrderCustomerApi: config.api_url+'order/place-order',
    // addOrderCustomerApi: config.api_url+'order/add-customer',
    getVariantByProductApi: config.api_url+'order/get-variant',
    getTimeSlotByDateApi: config.api_url+'order/get-timeslot-by-date',
    getTimeSloApi: config.api_url+'order/get-timeslot',

    getChargesApi: config.api_url+'order/get-charges',
    getShippingAddressApi: config.api_url+'order/get-shipping-address',
    checkQuantityApi: config.api_url+'order/check-quantity',
    getProductSearchingApi: config.api_url+'order/get-search-product',
    getOrderByIdApi: config.api_url+'order/get-order-by-id',
    getOrderDetailByIdApi: config.api_url+'order/get-order-detail',
    getOrderItemApi: config.api_url+'order/get-order-item',
    updateOrderApi: config.api_url+'order/update-order',
    getCouponApi: config.api_url+'order/get-coupon',
    createInvoiceApi: config.api_url+'order/create-invoice',
    InvoiceListApi: config.api_url+'invoice/list',
    InvoiceDownloadApi: config.api_url+'invoice/download',
    orderItemPayApi: config.api_url+'invoice/pay',
    getCreditApi: config.api_url+'order/getCredit',
    getOrderPaidUnpaidAmounts: config.api_url+'get-ordertransactions-amount',
    orderReadyToCollectApi: config.api_url+'order/ready-to-collect',
    adminOrderCancelApi: config.api_url+'admin/order/cancel',


    //Discount
    getDiscountApi: config.api_url+'get-discount',
    addDiscountApi: config.api_url+'add-discount',
    getDiscountByIdApi: config.api_url+'get-discount-by-id',
    discountImageDeleteUrl: config.api_url+'discount/delete-discount-by-name',
    updateDiscountApi: config.api_url+'update-discount',

    //Reports
    getSalesReportApi : config.api_url+'get-sale-report',
    getCustomerCreditApi: config.api_url + 'get-customer-credit-report',
    saleReportExportToCsvApi: config.api_url+'sale-report-export-csv',
    getItemReportApi : config.api_url+'get-item-report',
    getCustomerReportApi : config.api_url+'get-customer-report',
    reportcustomerExportToCsvApi : config.api_url+'report-customer-export-to-csv',
    totalSaleReportApi : config.api_url+'get-total-sale-report',
    getAllRestuarntApi : config.api_url+'get-all-restaurant',
    taxReportReportApi : config.api_url+'get-tax-report',
    getDriverReportApi: config.api_url+'get-driver-report-listing',
    getInactiveCustomerReportApi: config.api_url+'get-inactive-customer-report',
    getCODOnlineOrderReportApi: config.api_url+'get-cod-online-order-report',
    getVendorRatingReportApi: config.api_url+'get-vendor-avg-rating-report',
    getGSTDeliveryChargeReportApi: config.api_url+'get-gst-delivery-charge-report',
    getRestaurantsApi: config.api_url+'get-all-restuarants',
    totalSaleReportExportToCsvApi: config.api_url+'total-sale-report-export-csv',
    getRestaurantsConfirmApi: config.api_url+'get-restaurants-confirm',
    taxReportExportToCsvApi: config.api_url+'tax-report-export-to-csv',
    getAllUserApi: config.api_url+'get-all-user',
    exportInactiveCustomerApi: config.api_url+'export-inactive-customer',
    exportVendorAvgRatingApi: config.api_url+'vendor-avg-export-to-csv',
    exportGSTDelivertReportApi: config.api_url+'gst-delivery-export-to-csv',
    exportCODOnlineReportApi: config.api_url+'export-to-cod-online',
    getPromoCodereportApi: config.api_url+'get-promo-code-report',
    getVendorRatingReviewReportApi: config.api_url+'get-vendor-rating-review-report',
    exportVendorRatingReviewReportApi: config.api_url+'export-vendor-rating-review-report',
    getDriverRatingReviewReportApi: config.api_url+'get-driver-rating-review-report',
    exportDriverRatingReviewReportApi: config.api_url+'export-driver-rating-review-report',

    //Dashboard
    getDashboardApi :  config.api_url+'get-dashboard',
    getMonthWiseOrderApi : config.api_url+'get-month-wise',
    getMonthWiseSalesApi :  config.api_url+'get-month-wise-sales',
    getMonthWiseEarning : config.api_url+'get-month-wise-earning',
    getMonthWiseCancelOrderApi :  config.api_url+'get-month-wise-cancel-order',
    getMonthWiseCustomerApi : config.api_url+'get-month-wise-customer',
    getMonthWiseDeliveredOrderApi : config.api_url+'get-month-wise-delivered-order',
    getOrderAverageApi : config.api_url+'get-order-average-amount',

    //Menu Image
    addMenuImageApi :  config.api_url+'add-menu-image',

    cancelOrderApi: config.api_url + 'order/cancel',
    deliverOrderApi: config.api_url + 'order/deliver',
    /// APP APIS STARTED FROM HERE

    changeOrderStatusApi: config.api_url + 'edit_order_status',
    ownerOrderStatusApi: config.app_api_url + 'owner_order_status',

    //Customization
    getItemCustmizationApi : config.api_url+'get-item-customization',
    addCustmizationApi : config.api_url+'add-item-customization',
    getCustmizationTypeApi : config.api_url+'get-customization-type',
    customizationEditApi : config.api_url+'update-customization-type',
    deleteCustmizationTypeApi : config.api_url+'delete-customization-type',
    saveTemplateApi : config.api_url+'save-template',
    deleteItemCustmizationApi : config.api_url+'delete-item-customization',
    getTemplateApi : config.api_url+'get-template',
    addTemplateApi : config.api_url+'add-template',
    addMenuSelectionApi : config.api_url+'add-menu-selection',
    getSubCustomizationApi : config.api_url+'get-sub-customization',
    minSelectionApi : config.api_url+'min-selection',
    maxSelectionApi : config.api_url+'max-selection',
    addSubMenuSelectionApi : config.api_url+'add-sub-menu-selection',

    //ContectPage
    getContentPageApi : config.api_url+'get-content-page',
    addContentPageApi : config.api_url+'add-content-page',
    getContentPageByIdApi : config.api_url+'get-content-page-by-id',
    editContentPageApi : config.api_url+'edit-content-page',
    viewContentPageApi : config.api_url+'view-content-page',
    deleteContentPageApi : config.api_url+'delete-content-page',
    getStaticPageApi : config.api_url+'get-static-page',
    getVendorTermApi : config.api_url+'get-vendor-term-page',

    //ForgotPassword
    forgotPasswordApi : config.api_url+'forgot-password',

    //HelpPage
    getHelpPageApi : config.api_url+'get-help-page',

    //Update
    getUpdateApi : config.api_url+'get-updates',

    //Client
    getClientApi : config.api_url+'get-client',
    addClientApi : config.api_url+'add-client',
    getClientByIdApi: config.api_url+'get-client-by-id',
    updateClientApi : config.api_url+'update-client',
    updateClientStatusApi : config.api_url+'update-client-status',

    //Currency
    getCurrencyApi : config.api_url+'get-currency',
    addCurrencyApi : config.api_url+'add-currency',
    getCurrencyByIdApi : config.api_url+'get-currency-by-id',
    updateCurrencyApi : config.api_url+'update-currency',

    //Product
    getProductApi : config.api_url+'get-product',
    getMainCategoryApi : config.api_url+'get-main-category',
    getSubCategoryApi : config.api_url+'get-sub-category',
    getAllProductBrandApi : config.api_url+'get-all-product-brand',
    addProductApi : config.api_url+'add-product',
    getProductByIdApi : config.api_url+'get-product-by-id',
    editProductApi : config.api_url+'edit-product',
    deleteProductApi : config.api_url+'delete-product',
    productImageDeleteUrl : config.api_url+'delete-product-image',
    getSearchProductApi : config.api_url+'get-search-product',
    getSearchProductByNameApi : config.api_url+'get-search-product-name',
    getSearchSubCategoryApi : config.api_url+'get-search-sub-category',
    getProductListApi: config.api_url+'get-product-list',

    //Sub Product
    getSubProductApi : config.api_url+'get-sub-product',
    getProductTagApi : config.api_url+'get-product-tag',
    addSubProductApi : config.api_url+'add-sub-product',
    getSubProductByIdApi : config.api_url+'get-sub-product-by-id',
    deleteSubProductApi : config.api_url+'delete-sub-product',
    getCatAttributeApi : config.api_url+'get-cat-attribute',
    subImageDeleteUrl : config.api_url+'sub-image-delete',
    editSubProductApi : config.api_url+'edit-sub-product',
    getRefundPriceApi : config.api_url+'get-refund-price',
    getProductBoxApi : config.api_url+'get-product-boxes',
    getSubProductListApi : config.api_url+'get-subproduct-list',
    updateSubProductOrderApi: config.api_url+'update-sub-product-order',
    updateSubProductQuantityApi : config.api_url+'update-sub-product-quantity',
    // Subscription
    getSubscriptionApi : config.api_url+'get-subscription',
    getSubscriptionProductApi : config.api_url+'get-subscription-product',
    getSubscriptionByIdApi : config.api_url+'get-subscription-by-id',

    // TimeSlot
    addTimeSlotApi : config.api_url+'add-time-slot',
    getTimeSlotApi : config.api_url+'get-time-slot',
    deleteTimeSlotApi : config.api_url+'delete-time-slot',
    getTimeSlotByIdApi : config.api_url+'get-time-slot-by-id',
    editTimeSlotApi : config.api_url+'update-time-slot',
    driversCountApi : config.api_url+'drivers-count',
    getDataCustomerTypeApi : config.api_url+'get-data-customer-type',

    //Attribute
    getAttributeListApi : config.api_url+'get-attribute-list',
    addAttributeApi : config.api_url+'add-attribute',
    getAttributeByIdApi : config.api_url+'get-attribute-by-id',
    editAttributeApi : config.api_url+'edit-attribute',
    deleteAttributeApi : config.api_url+'delete-attribute',
    getallBoxCategoryApi : config.api_url+'get-box-category-list',
    boxImageDeleteUrl : config.api_url+'delete-box-image',

    //Alert
    storeAlertApi: config.api_url+'store-alert',
    getAlertsListapi: config.api_url+'get-alerts',
    getAlertById: config.api_url+'get-alert-by-id',
    updateAlert: config.api_url+'update-alert',
    deleteAlertApi: config.api_url+'delete-alert',

    //Deals
    storeDealApi: config.api_url+'store-deal',
    getDealListApi: config.api_url+'get-deals',
    deleteDealApi: config.api_url + 'delete-deal',
    getDealById: config.api_url + 'get-deal-by-id',
    updateDeal: config.api_url + 'update-deal',
    sendNotificationsForDeals: config.api_url + 'notification-send-deals',

    //Popular Search
    getPopularSearchDataApi: config.api_url+'get-popular-search-data',
    getPopularSearchByIdApi: config.api_url+'get-popular-search-by-id',
    getPopularSearchApi: config.api_url+'get-popular-search',
    addPopularSearchApi: config.api_url+'add-popular-search',
    getPopularSearchListApi: config.api_url+'get-popular-search-list',
    editPopularSearchApi: config.api_url+'edit-popular-search',
    deletePopularSearchApi: config.api_url+'delete-popular-search',
    updatePopularSearchOrderApi: config.api_url+'update-popular-search-order',

    // couponRedeem: config.app_api_url+'get_order_timeslots',
    // timeslot:'http://127.0.0.1:8000/api/v1/'+'get_order_timeslots'


    // Producer Company
    getProducerCompanyApi : config.api_url+'get-producer-company',
    addProducerCompanyApi : config.api_url+'add-producer-company',
    getProducerCompanyByIdApi : config.api_url+'get-producer-company-by-id',
    editProducerCompanyApi : config.api_url+'edit-producer-company',
    deleteProducerCompanyApi : config.api_url+'delete-producer-company',

    //supplier
    getProducerCompanyNameApi : config.api_url+'get-producer-company-name',
    addSupplierApi:  config.api_url+'add-supplier',
    getSupllierListApi: config.api_url+'get-supplier-list',
    getSupplierProductListApi: config.api_url+'get-supplier-product-list',
    editSupplierApi: config.api_url+'edit-supplier',
    getSupplierByIdApi: config.api_url+'get-supplier-by-id',
    getAllSupplierProductByNameApi : config.api_url+'get-search-product-sub-product-name',
    getSubProductTaxApi: config.api_url+'get-sub-product-tax',
    deleteSupplierApi: config.api_url+'delete-supplier',
    // Producer Brand
    getProducerBrandApi : config.api_url+'get-producer-brand',
    addProducerBrandApi : config.api_url+'add-producer-brand',
    getProducerBrandByIdApi : config.api_url+'get-producer-brand-by-id',
    editProducerBrandApi : config.api_url+'edit-producer-brand',
    deleteProducerBrandApi : config.api_url+'delete-producer-brand',
    brandImageDeleteUrl: config.api_url+'delete-producer-brand-image',

    //Contact
    storeContactApi: config.api_url+'store-contact',
    getContactApi: config.api_url+'get-contact',
    deleteContact: config.api_url + 'delete-contact',
    getContactById: config.api_url + 'get-contact-by-id',
    updateContact: config.api_url + 'update-contact',
}


export { routes }